
export const bigintMin = (...values: bigint[]): bigint => {
  return values.reduce((min, current) => (current < min ? current : min));
}